import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import HydrationSettingsMutation from './HydrationSaveSettingsMutation';

const HydrationSaveSettingsConnectorApollo = ({ children, rawQueryResult }) => {
  const [mutate, { data, loading }] = useMutation(HydrationSettingsMutation);

  const createSave = async (settings) => {
    const variables = { settings };

    if (rawQueryResult) {
      const optimisticResponse = {
        me: {
          hydrationSettings: {
            ...rawQueryResult.me.hydrationSettings,
            defaultDailyGoal: {
              ...rawQueryResult.me.hydrationSettings.defaultDailyGoal,
              value: settings.defaultDailyGoal.value,
            },
          },
        },
      };

      await mutate({
        variables,
        optimisticResponse,
        update: (cache, { data: response }) => {
          cache.modify({
            id: cache.identify(rawQueryResult.me),
            fields: {
              hydrationSettings(existingHydrationSettings) {
                return {
                  ...existingHydrationSettings,
                  defaultDailyGoal: {
                    ...existingHydrationSettings.defaultDailyGoal,
                    value: response.me.hydrationSettings.defaultDailyGoal.value,
                  },
                };
              },
            },
          });
        },
      });
    } else {
      await mutate({ variables });
    }
  };

  if (data) {
    const result = data.me.hydrationSettings;
    if (result.__typename === 'ValidationException') {
      throw result;
    }
  }

  return children({ save: createSave, loading });
};

HydrationSaveSettingsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  rawQueryResult: PropTypes.object,
};

HydrationSaveSettingsConnectorApollo.defaultProps = {
  rawQueryResult: null,
};

export { HydrationSaveSettingsConnectorApollo };
export default HydrationSaveSettingsConnectorApollo;
